import { InvoiceStatus } from '@cyberlabrs/helpers';

export enum ClientType {
    COMPANY = 'COMPANY',
    INDIVIDUAL = 'INDIVIDUAL',
}

export enum Currency {
    RSD = 'RSD',
    USD = 'USD',
    EUR = 'EUR',
}

export enum BillingInterval {
    MONTHLY = 'Monthly',
    WEEKLY = 'Weekly',
    CUSTOM = 'Custom',
}

type ICustomFieldForm = {
    label: string;
    value: string;
};

interface IContactForm {
    firstName: string;
    lastName: string;
    workPhoneNumber?: string;
    mobilePhoneNumber?: string;
    email: string;
    position?: string;
}

export interface CreateContactDto extends IContactForm {}

export interface PatchContactDto {
    id: string;
    firstName?: string;
    lastName?: string;
    workPhoneNumber?: string;
    mobilePhoneNumber?: string;
    email?: string;
    position?: string;
}

export interface CreateClientDto {
    organizationId: string;
    type: ClientType;
    name: string;
    displayName: string;
    email: string;
    workPhoneNumber?: string;
    mobilePhoneNumber?: string;
    honorifics?: string;
    representativeFirstName: string;
    representativeLastName: string;
    website?: string;
    currency: string;
    billingAddress?: IClientFormAddress;
    shippingAddress?: IClientFormAddress;
    contacts?: IContactForm[];
    customFields?: ICustomFieldForm[];
    remarks?: string;
    billingInterval: string;
    registrationNumber?: string;
    taxNumber?: string;
    taxNumberLabel: string;
    registrationNumberLabel: string;
}

export type IClientFormAddress = {
    id?: string;
    countryId: string;
    state?: string;
    city: string;
    streetline1: string;
    streetline2?: string;
    postalCode?: string;
};

export type AddressDto = {
    id?: string;
    countryId?: string;
    state?: string;
    city: string;
    streetline1: string;
    streetline2?: string;
    postalCode?: string;
};

export type ContactDto = {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    position: string;
    workPhoneNumber?: string;
    mobilePhoneNumber?: string;
    clientId: string;
};

type CustomFieldDto = {
    id: string;
    label: string;
    value: string;
};

export interface ClientDto {
    id: string;
    organizationId: string;
    type: ClientType;
    name: string;
    displayName: string;
    email: string;
    workPhoneNumber?: string;
    mobilePhoneNumber?: string;
    honorifics?: string;
    representativeFirstName: string;
    representativeLastName: string;
    website?: string;
    currency: string;
    billingAddress: AddressDto;
    shippingAddress: AddressDto;
    contacts?: ContactDto[];
    customFields?: CustomFieldDto[];
    remarks?: string;
    createdAt: string;
    updatedAt: string;
    billingInterval: string;
    registrationNumber?: string;
    taxNumber?: string;
    registrationNumberLabel: string;
    taxNumberLabel: string;
}

export interface InvoiceClientDto extends ClientDto {
    name: string;
    billingStreet: string;
    billingCity: string;
    countryId: string;
    mobilePhoneNumber: string;
    workPhoneNumber: string;
    registrationNumber: string;
    taxNumber: string;
}
export interface ClientPublicDto {
    id: string;
    name: string;
    currency: string;
}

export interface ClientTab {
    client: ClientDto;
}

export interface UpdateClientDto {
    type?: '' | 'COMPANY' | 'INDIVIDUAL';
    name?: string;
    displayName?: string;
    email?: string;
    workPhoneNumber?: string;
    mobilePhoneNumber?: string;
    honorifics?: string;
    representativeFirstName?: string;
    representativeLastName?: string;
    website?: string;
    currency?: string;
    rateUpdateMode?: 'convert' | 'keep_numeric';
    billingAddress?: {
        countryId: string;
        state?: string;
        city: string;
        streetline1: string;
        streetline2?: string;
        postalCode?: string;
    };
    shippingAddress?: {
        countryId: string;
        state?: string;
        city: string;
        streetline1: string;
        streetline2?: string;
        postalCode?: string;
    };
    remarks?: string;
    billingInterval?: string;
    registrationNumber?: string;
    taxNumber?: string;
    registrationNumberLabel?: string;
    taxNumberLabel?: string;
}

export type OrganizationClientsCount = {
    countClients: number;
    createdAtCount: number;
};

export type TermDto = {
    id: string;
    name: string;
    numberOfDays: number;
    organizationId: string | null;
    markedAsObsolete: boolean;
    isPredefined?: boolean;
};

export type PostTermsDto = Pick<TermDto, 'name' | 'numberOfDays'>;

export type PatchTermDto = Partial<PostTermsDto>;

export type InvoiceDataItemDto = {
    id?: string;
    projectId?: string;
    userSub?: string;
    quantity: number;
    rate: string;
    tax: number;
    amount: string;
    item?: string;
};
export type PostInvoiceDto = {
    clientId: string;
    number: string;
    notes?: string;
    termsAndConditions?: string;
    organizationId?: string;
    templateId?: string;
    status?: InvoiceStatus;
    total?: number;
    from?: string;
    to?: string;
    invoiceDate?: string;
    dueDate: string;
    invoiceData?: InvoiceDataItemDto[];
};

export type ClientSummaryOverviewDto = {
    projectId: string;
    projectName: string;
    assigneeName: string;
    imageUrl?: string;
    title?: string;
    hourlyRate: number | null;
    totalLogged: number;
};
